import { isDiscountLinkPurpose } from './discountLinkPurpose';

/**
 * Read a member referral code from the landing URL.
 * Share links use ?ref= (walkmore.move-club.co?ref=CODE). Legacy /join/CODE and /r/CODE paths still work.
 * Discount emails also used ?ref=checkout_recovery (and the other discount purposes). Those are not referrals.
 */
export function extractReferralCodeFromLocation(search: string, pathname: string): string | null {
    const query = search.startsWith('?') ? search.slice(1) : search;
    const params = new URLSearchParams(query);
    const fromQuery = params.get('ref') || params.get('referralCode');
    if (fromQuery?.trim() && !isDiscountLinkPurpose(fromQuery)) {
        return fromQuery.trim();
    }

    const pathMatch = pathname.match(/\/(?:join|r)\/([^/?#]+)/i);
    const fromPath = pathMatch?.[1];
    if (!fromPath) {
        return null;
    }
    try {
        const decoded = decodeURIComponent(fromPath).trim();
        return decoded || null;
    } catch {
        return fromPath.trim() || null;
    }
}
